import _ from 'underscore';
import Util from 'root/module/util';
import UI from 'root/ui';
import View from 'view/base';

export default View.extend({
    className: 'integration-log-sidebar',

    events: {
        'click .response-body-copy': 'onCopyResponseBody',
        'click .request-body-copy' : 'onCopyRequestBody',
    },

    dom_handlers: {
        onCopyResponseBody: function() {
            Util.copyText(this.model.get('body'), () => {
                UI.success('Response body copied.');
            });
        },

        onCopyRequestBody: function() {
            Util.copyText(this.model.get('request_body'), () => {
                UI.success('Request body copied.');
            });
        },
    },

    render: function() {
        var response_body = this.model.get('body');
        var request_body  = this.model.get('request_body');

        var error_content =
            '<p class="session-title">Error Details</p>' +
            '<div class="response-body box-neutral-light">' +
            (this.model.get('error') ? '<div>' + this.model.get('error') + '</div>' :
            '<div class="empty">Data not recorded</div>') +
            '</div>';

        var request_content =
            '<p class="session-title">Response Body</p>' +
            '<div class="response-body box-neutral-light">' +
                (response_body ? '<div class="response-body-copy"><span class="tooltip" data-title="Copy"><i class="fa-solid fa-copy"></i></span></div><div>' + Util.jsonHighlight(response_body) + '</div>' :
                '<div class="empty">Data not recorded</div>') +
            '</div>' +
            '<div class="divider-8"></div>' +
            '<hr class="small"></hr>' +
            '<p class="session-title">Request Body</p>' +
            '<div class="request-body box-neutral-light">' +
                (request_body ? '<div class="request-body-copy"><span class="tooltip" data-title="Copy"><i class="fa-solid fa-copy"></i></span></div><div>' + Util.jsonHighlight(request_body) + '</div>' :
                '<div class="empty">Data not recorded</div>') +
            '</div>';

        if (this.model.get('error') && !response_body) {
            // error, but no response body just shows the error
            request_content = error_content;
        } else if (this.model.get('error')) {
            // error and response body shows both
            request_content = error_content + '<hr class="small"></hr>' + request_content;
        }

        var content =
        '<div class="layout-main">' +
            '<div class="integration-type">' +
                (this.model.get('type') ? '<img src="' + (this.model.getIntegrationInfo().logo) + '">' : '') +
                this.model.getIntegrationInfo().name +
            '</div>' +
            '<div class="request-url">' + this.model.escape('request_url') + '</div>' +
            '<div class="log-info">' +
                '<div class="title">Status:</div>' +
                '<div class="value">' +
                    '<span class="' + (this.model.isError() ? 'badge-danger-invert' : 'badge-success-invert') + '">' + this.model.getStatusText() + '</span>' +
                '</div>' +
                '<div class="title">Method:</div>' +
                '<div class="value">' + this.model.get('request_method') + '</div>' +
                '<div class="title">Time:</div>' +
                '<div class="value">' + Util.moment(this.model.escape('timestamp'), 'DD MMM YYYY h:mm a', undefined, false) + '</div>' +
            '</div>' +
            '<hr class="small"></hr>' +
            request_content +
        '</div>';

        this.$el.html(content);

        return this;
    }
});